import React from 'react'
import propTypes from 'prop-types'
import { connect } from 'react-redux'
import { Icon, MenuItem, Spinner } from '@blueprintjs/core'

import InputSelect from './InputSelect'
import {
    getTeamSearchResults,
    getCmdbTeams,
} from 'src/store/modules/cmdb/teams'

const customerRenderer = (customer, { handleClick, modifiers }) => {
    return (
        <MenuItem
            active={modifiers.active}
            key={customer.id}
            text={customer.name}
            onClick={handleClick}
        />
    )
}

class TeamSelect extends React.Component {
    renderInputValue = (customer) => customer.name

    componentDidMount() {
        this.props.getCmdbTeams('', '?exists_only=true')
    }

    render() {
        const {
            selected,
            customers,
            loading,
            fill,
            getCmdbTeams,
            onTeamSelect,
            large,
        } = this.props
        return (
            <InputSelect
                inputProps={{
                    placeholder: 'Search for a team',
                    large,
                    rightElement: loading ? (
                        <Spinner size={Icon.SIZE_STANDARD} />
                    ) : null,
                }}
                itemRenderer={customerRenderer}
                noResults={
                    loading ? (
                        <MenuItem disabled text={'Loading...'} />
                    ) : (
                        <MenuItem disabled text="No results" />
                    )
                }
                items={customers}
                inputValueRenderer={this.renderInputValue}
                onQueryChange={(value) =>
                    getCmdbTeams(value, '?exists_only=true')
                }
                popoverProps={{
                    minimal: true,
                    targetClassName: fill ? 'full-width' : '',
                }}
                onItemSelect={(customer) => onTeamSelect(customer)}
                selectedItem={selected}
            />
        )
    }
}

TeamSelect.propTypes = {
    onTeamSelect: propTypes.func.isRequired,
    getCmdbTeams: propTypes.func.isRequired,
    selected: propTypes.shape({
        name: propTypes.string.isRequired,
        id: propTypes.number.isRequired,
    }),
    large: propTypes.bool,
    fill: propTypes.bool,
}

TeamSelect.defaultProps = {
    large: false,
    fill: true,
}

export default connect(
    (state) => ({
        customers: getTeamSearchResults(state),
        loading: state.cmdb.teams.loading,
    }),
    { getCmdbTeams }
)(TeamSelect)
